export function getTabletDesktopStyles() {
  return require('./styles.css');
}
